var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralActionShareiOsWhite = function SvgGeneralActionShareiOsWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 12v9H7.502A2.254 2.254 0 0 1 5.25 18.75V12h-1.5v6.749A3.756 3.756 0 0 0 7.502 22.5H20.25V12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 4.374v12.118h1.5V4.374l3.434 3.44 1.061-1.06L12 1.5 6.754 6.753l1.062 1.06z"
  }))));
};
export default SvgGeneralActionShareiOsWhite;